import { FieldAttributes } from 'formik';
import React from 'react';
import FieldWithError from './FieldWithError';

export type LabeledFieldProps = FieldAttributes<unknown> & {
  label: string;
  labelClassName?: string;
};

const LabeledField = ({
  name,
  label,
  className = '',
  labelClassName = '',
  ...rest
}: LabeledFieldProps) => {
  return (
    <div>
      <label htmlFor={name}>
        <p className={'inline-block mr-2 ' + labelClassName}>{label}:</p>
        <FieldWithError name={name} {...rest} className={className + ' bg-white px-2 py-1'} />
      </label>
    </div>
  );
};

export default LabeledField;
